import { Component } from '@angular/core';

@Component({
    selector: 'app-agenda',
    templateUrl: './agenda.component.html',
    styleUrl: './agenda.component.css',
    standalone: false
})
export class AgendaComponent {

}
